// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"133":"367f36e1","698":"27e720d7"}[chunkId] + ".js";
};